import jwtDecode from "jwt-decode";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const PornitesHome = () => {
    const navigate = useNavigate();

    useEffect(() => {
        if (localStorage.getItem("compiauthtoken")) {
            if (
                jwtDecode(localStorage.getItem("compiauthtoken")).user
                    .username === "pronites"
            ) {
            } else {
                navigate("/admin/competitions");
            }
        } else {
            navigate("/admin/login");
        }
    }, []);
    return (
        <div className="container-fluid">
            <h3>Select Competition to Proceed</h3>
            <div className="row">
                <button
                    className="btn btn-primary col-4"
                    onClick={() => {
                        navigate("/admin/pronites/livewire");
                    }}
                >
                    LiveWire
                </button>
                <div className="col-2"></div>
                <button
                    type="button"
                    class="btn btn-success col-4"
                    onClick={() => {
                        navigate("/admin/pronites/soulstrings");
                    }}
                >
                    SoulStrings
                </button>
            </div>
        </div>
    );
};

export default PornitesHome;
